import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs-compat";
import { AuthService } from "../providers/auth.provider";
import { CONST } from "../providers/const";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private entornoService: AuthService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('/inicio-sesion') || request.url.endsWith('/cierre-sesion')) {
      return next.handle(request);
    }

    var token: any = this.entornoService.getToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          'X-Auth-Token': token
        }
      });
    }

    return next.handle(request).catch(error => this.handleError(error));
  }

  handleError(error: HttpErrorResponse): Observable<any> {
    if (error.status === 401) {
      sessionStorage.removeItem(CONST.LOCALSTORAGE.token);
      sessionStorage.removeItem(CONST.LOCALSTORAGE.user);
      localStorage.setItem(CONST.LOCALSTORAGE.errorLogin, (error.error && error.error.message ? error.error.message : 'Session Invalidated'))
      this.router.navigate(['/public/home']);
      //   return Observable.of(error.message);
    }

    if (error.status === 403) {
      sessionStorage.removeItem(CONST.LOCALSTORAGE.token);
      sessionStorage.removeItem(CONST.LOCALSTORAGE.user);
      localStorage.setItem(CONST.LOCALSTORAGE.errorLogin, (error.error && error.error.message ? error.error.message : 'Session Invalidated'))
      this.router.navigate(['/public/home']);
      //   return Observable.of(error.message);
    }

    return Observable.throw(error);
  }

}